<label class="form-label">{{ label }}</label>
<div class="row">
  <div class="col">
    <app-color #color (change)="onChange()" label="Color" [opacityEnabled]="true"></app-color>
  </div>
  <div class="col">
    <label class="form-label">Offset X</label>
    <div class="d-flex align-items-center">
      <input class="ms-1 form-control form-width" [(ngModel)]="offsetX" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChange()"
             type="number" [disabled]="isDisabled()">
      <span class="ms-1 fw-bold">px</span>
    </div>
  </div>
  <div class="col">
    <label class="form-label">Offset Y</label>
    <div class="d-flex align-items-center">
      <input class="ms-1 form-control form-width" [(ngModel)]="offsetY" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChange()"
             type="number" [disabled]="isDisabled()">
      <span class="ms-1 fw-bold">px</span>
    </div>
  </div>
  <div class="col">
    <label class="form-label">Blur radius</label>
    <div class="d-flex align-items-center">
      <input class="ms-1 form-control form-width" [(ngModel)]="blurRadius" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChange()"
             type="number" [disabled]="isDisabled()">
      <span class="ms-1 fw-bold">px</span>
    </div>
  </div>
  <div class="col">
    <label class="form-label">Spread radius</label>
    <div class="d-flex align-items-center">
      <input class="ms-1 form-control form-width" [(ngModel)]="spreadRadius" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChange()"
             type="number" [disabled]="isDisabled()">
      <span class="ms-1 fw-bold">px</span>
    </div>
  </div>
</div>
